import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import type { ButtonHTMLAttributes } from 'react'

import type { ButtonProps } from './Button.types'
import { Icon } from './Icon'

/** GXLabs Button: uppercase, bracketed label; `primary` (cyan) is the one main action per view. */
export function Button({
  variant = 'secondary',
  size = 'md',
  icon,
  brackets = true,
  loading,
  children,
  className,
  disabled,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = [
    'btn',
    variant !== 'secondary' && `btn--${variant}`,
    size === 'sm' && 'btn--sm',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <span className="spinner" style={{ width: 12, height: 12 }} />
      ) : icon ? (
        <Icon icon={icon} />
      ) : null}
      {children !== undefined &&
        (brackets ? (
          <span>
            <span className="btn__bracket">[ </span>
            {children}
            <span className="btn__bracket"> ]</span>
          </span>
        ) : (
          <span>{children}</span>
        ))}
    </button>
  )
}

export function IconButton({
  icon,
  label,
  ...rest
}: {
  icon: IconDefinition
  label: string
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      className="icon-btn"
      aria-label={label}
      title={label}
      {...rest}
    >
      <Icon icon={icon} />
    </button>
  )
}
